import React from "react"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
// import SocialAuth from "../SocialAuth"
// import SeparatorWithText from "../../../../ui/atoms/SeparatorWithText"
import CustomTextInput from "../../../../ui/atoms/CustomTextInput"
import CustomPasswordInput from "../../../../ui/molecules/CustomPasswordInput"
import CustomButton from "../../../../ui/atoms/Button"
import { useAppDispatch, useAppSelector } from "../../../../state/store"
import { useAuthContents } from "../../../../contents/auth/context"
import CustomAlert from "../../../../ui/atoms/Alert"
import { login } from "../../state/login/loginActions"
import { buildPasswordResetUrl } from "../../navigation/urls"
import { EditorialLabel } from "../../../contents"
import { useRouter } from "next/router"

interface Props {
  redirectUrl?: string
  callback?: () => void
  defaultEmail?: string
  forgotPasswordControl?: React.ReactNode
}

interface FormData {
  username: string
  password: string
}

const schema = yup.object().shape({
  username: yup.string().required(),
  password: yup.string().required(),
})

const LoginForm = ({
  redirectUrl,
  callback,
  defaultEmail,
  forgotPasswordControl,
}: Props) => {
  const { login: contents } = useAuthContents()
  const router = useRouter()
  const {
    register,
    errors: { username, password },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      username: defaultEmail ?? "",
      password: "",
    } as any,
  })
  const dispatch = useAppDispatch()
  const { error, wrongCredentials, oldUser, isLoading } = useAppSelector(
    (state) => state.login
  )

  const fields = {
    username: {
      name: "username",
      label: contents.form.usernameLabel,
      error: username,
    },
    password: {
      name: "password",
      label: contents.form.passwordLabel,
      error: password,
    },
  }

  const onSubmit = ({ username, password }: FormData) => {
    dispatch(
      login(
        {
          username,
          password,
          pwdResetBaseUrl: buildPasswordResetUrl(),
        },
        () => {
          if (redirectUrl) {
            router.push(redirectUrl)
          }
          if (callback) {
            callback()
          }
        }
      )
    )
  }

  return (
    <div>
      {/* <SocialAuth redirectUrl={redirectUrl} />
      <SeparatorWithText my={2}>
        {contents.form.socialAndEmailLoginSeparator}
      </SeparatorWithText> */}
      <div className="my-3">
        <CustomTextInput
          name={fields.username.name}
          inputRef={register}
          required
          label={fields.username.label}
          fullWidth
          autoComplete="off"
          error={!!fields.username.error}
        />
      </div>
      <div className="mt-2 mb-4">
        <CustomPasswordInput
          name={fields.password.name}
          register={register}
          required
          label={fields.password.label}
          fullWidth
          error={!!fields.password.error}
          onEnterKey={handleSubmit(onSubmit)}
        />
        {forgotPasswordControl && <div>{forgotPasswordControl}</div>}
      </div>
      <div className="mt-8 mb-4">
        <CustomButton
          variant="contained"
          size="medium"
          onClick={handleSubmit(onSubmit)}
          loading={isLoading}
        >
          {contents.form.emailLoginCta}
        </CustomButton>
      </div>
      <CustomAlert severity="warning" show={wrongCredentials || error}>
        <EditorialLabel scope="login" id="wrong-credentials" variant="body1" />
      </CustomAlert>
      <CustomAlert severity="success" show={oldUser}>
        <EditorialLabel scope="login" id="old-user-login" variant="body1" />
      </CustomAlert>
    </div>
  )
}

export default LoginForm
